<template>
  <div>
    <div class="mainbody">
<!--      <code>{{ restaurants }}</code>-->
      <div class="restaurents">
        <div class="row mt10">
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 col-xss-12 mt15 mb15"  v-for="restaurant in restaurants">
            <div class="restaurent">
              <div class="restaurent__image-wrap">
                <router-link  :to="{ path: '/restaurant/'+restaurant.slug}">
                <img v-bind:src="fileUrl+'uploads/restaurants/'+restaurant.image" :alt="restaurant.restaurant_name_en"
                  alt="Raya Catering" class="restaurent__image">
                <span class="overlay"></span>
                <!--            <div class="rating-wrap">-->
                <!--              <span style="cursor: default;"><div class="rating-symbol" style="display: inline-block; position: relative;"><div class="rating-symbol-background glyphicon glyphicon-star-empty" style="visibility: visible;"></div><div class="rating-symbol-foreground" style="display: inline-block; position: absolute; overflow: hidden; left: 0px; right: 0px; width: 0%;"><span class="glyphicon glyphicon-star"></span></div></div><div class="rating-symbol" style="display: inline-block; position: relative;"><div class="rating-symbol-background glyphicon glyphicon-star-empty" style="visibility: visible;"></div><div class="rating-symbol-foreground" style="display: inline-block; position: absolute; overflow: hidden; left: 0px; right: 0px; width: 0px;"><span class="glyphicon glyphicon-star"></span></div></div><div class="rating-symbol" style="display: inline-block; position: relative;"><div class="rating-symbol-background glyphicon glyphicon-star-empty" style="visibility: visible;"></div><div class="rating-symbol-foreground" style="display: inline-block; position: absolute; overflow: hidden; left: 0px; right: 0px; width: 0px;"><span class="glyphicon glyphicon-star"></span></div></div><div class="rating-symbol" style="display: inline-block; position: relative;"><div class="rating-symbol-background glyphicon glyphicon-star-empty" style="visibility: visible;"></div><div class="rating-symbol-foreground" style="display: inline-block; position: absolute; overflow: hidden; left: 0px; right: 0px; width: 0px;"><span class="glyphicon glyphicon-star"></span></div></div><div class="rating-symbol" style="display: inline-block; position: relative;"><div class="rating-symbol-background glyphicon glyphicon-star-empty" style="visibility: visible;"></div><div class="rating-symbol-foreground" style="display: inline-block; position: absolute; overflow: hidden; left: 0px; right: 0px; width: 0px;"><span class="glyphicon glyphicon-star"></span></div></div></span><input type="hidden" class="rating" value="0" data-readonly="">-->
                <!--            </div>-->
                </router-link>
              </div>

              <div class="restaurent__text-content">
                <h4 class="restaurent__title">
                  <router-link  :to="{ path: '/restaurant/'+restaurant.slug}">
                 {{ restaurant.restaurant_name_en }}
                    </router-link>
                </h4>
                <div class="small-text food-item__meta">
                  <span>{{ restaurant.address_en }}</span>
                </div>
                <div class="restaurent__price-book mt10">
                  <div class="restaurent__booking base-color full-width text-center">
                    <router-link  :to="{ path: '/restaurant/'+restaurant.slug}" class="btn btn--small">Order Now</router-link>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="cart-data animated ">
        <div class="left-arrow cart-summary-toggle">
          <i class="fa fa-angle-left"></i>
          <span class="cart-summary-info">
            <span class="cart-summary-count">
              {{ carts.length || 0 }}  item{{ carts.length == 1 ? "" : "s" }}
            </span>
            <span class="cart-summary-total">{{ (sum_cart_total || 0).toFixed(2) }} &#8364;</span>
          </span>
        </div>

        <div class="delivery-charge" v-if="carts.length>0 && sum_cart_total<1000">Order More Than 1000 &#8364; & Get FREE
          Delivery.
        </div>
        <div class="delivery-charge off" v-if="sum_cart_total>=1000">&nbsp;Your Delivery Charge is off.</div>
        <div class="product-lists" v-if="carts.length>0">

          <table class="table table-striped table-responsive">
            <tr v-for="(cart , cartindex) in carts" v-bind:id="cart.product_id">
              <!--<td>{{cart.product_id}}</td>-->
              <td class="text-center cart-quantity">
                <div class="border-line">
                  <div data-toggle="tooltip" data-placement="left" title="+ Increase Quantity">
                    <span @click="cartIncrement(cart.product_id)"><img src="@/assets/images/icons/arrow-top.png"
                                                                       width="15px"/></span>
                  </div>
                  <div class="cart_quantity">{{ cart.cart_quantity }}</div>
                  <div data-toggle="tooltip" data-placement="left" title="- Decrease Quantity">
                    <span @click="cartDecrement(cart.product_id)"><img src="@/assets/images/icons/arrow-bottom.png"
                                                                       width="15px"/></span>
                  </div>
                </div>
              </td>
              <td class="product-image-td">
                <div>
                  <img v-bind:src="fileUrl+'uploads/products/'+cart.product_image" class="img-responsive">
                </div>
              </td>
              <td class="product-name-td" @click="cartIncrement(cart.product_id)">
                <div>
                  <span v-if="globalLanguage=='EN'">{{ cart.product_name }}</span>
                  <span v-else>{{ cart.product_name_bn }}</span>
                  <br><small>{{ cart.price }} &#8364; / {{ cart.quantity }} {{ cart.unit }}</small></div>
              </td>
              <!--<td class="price-td">{{cart.price}}</td>-->
              <td class="  ">{{ cart.subtotal }} <span class="base-color">&#8364;</span></td>
              <td class="remove-td">
                <div @click="removeCartItem(cart.product_id)">
                  <img src="@/assets/images/icons/close-x.png" class="img-responsive">
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="text-center checkoutlink" v-if="carts.length>0">
          <div class="btn-group" role="group">
            <router-link type="button" to="/checkout" class="btn btn-secondary border-right">{{ sum_cart_total }} &#8364;
            </router-link>
            <router-link type="button" class="btn btn-secondary " to="/cart" v-if="carts.length>0">GO CHECKOUT
            </router-link>
          </div>
        </div>

        <div class="text-center empty-cart" v-if="carts.length<=0">
          <div class="text-center">
            <img src="@/assets/images/icons/emptycart.png" alt="">
            Your BAG Is Empty.Please Add <br> Product In Your BAG..
          </div>
        </div>
      </div>
    </div>
    <div class="mobilemenu">
      <div class="same">
        <router-link to="/" class="icon-bottom">
          <img
            src="@/assets/images/icons/home-ash.png" width="31px">
        </router-link >
      </div>
      <div class="gocheckout" v-if="carts.length>0">
        <router-link to="/cart">
          GO CHECKOUT
        </router-link>
      </div>
      <div class="gocheckout start" @click="toogleNav()" v-else>
        <span>
          START SHOPPING
        </span>
      </div>
      <div class="mybag same carts">
                <span>
                     <span class="badge">0</span>
                 <img class="iconbag" src="@/assets/images/icons/bag.png" alt="Shopping-bag" height="31px">

               </span>
      </div>
    </div>
  </div>
</template>
<script>
const $ = require('jquery');
window.$ = $;
$(function () {
  $(window)
    .scroll(function () {
      $('nav')
        .toggleClass('scrolled', $(this)
          .scrollTop() > 20);
    });
});
import axios from 'axios';

export default {
  data() {
    return {
      restaurants: [],
      menuStatus: true,
      modalProductData: [],
      recentViews: [],
      get_category_name: '',
      get_sub_category_name: '',
      get_child_category_name: '',
      loadMore: true,
      quantity: 1,
      images: [],
      changeModalGallery_image: '',
      categories: [],
      category_image: '',
      sub_categories: [],
      child_sub_categories: [],
      //carts  rlated  variables
      token: '',
      getcarts: [],
      carts: [],
      isOpen: true,
      sum_cart_total: '',
      parseCartData: [],
      activeItem: '',
      mainCategories: [],
      subCategories: [],
      language: '',
      childCategories: []
    };
  },
  created: function () {
    this.restaurantList();
    this.language = this.globalLanguage;
  },
  mounted() {
    let vm = this;
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      vm.carts = [];
    }
    this.calculateCartTotal();

  },
  watch: {
  },
  methods: {
    toogleNav: function () {
      $(".small-device #sidebar-area")
        .toggleClass('show');
      $("#content-area")
        .toggleClass('fullwidth');
      $("#sidebar-area")
        .toggleClass('hidden-sidebar');
      if (this.menuStatus == true) {
        this.menuStatus = false;
      } else if (this.menuStatus == false) {
        this.menuStatus = true;
      }
    },
    isActive: function (menuItem) {
      return this.activeItem === menuItem;
    },
    setActive: function (menuItem) {
      this.activeItem = menuItem; // no need for Vue.set()
    },
    increment(product_id) {
      //this.quantity++
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      if (objIndex != -1){
        let oldQuantity = this.carts[objIndex].cart_quantity;
        let stock_quantity = this.carts[objIndex].stock_quantity;
        if(this.quantity<stock_quantity){
          let newQuantity = oldQuantity + 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
          $('#' + product_id + " .amountQuantity")
            .text(newQuantity);
          this.calculateCartTotal();
          this.quantity=newQuantity;
        }
      }else{
        let objIndex = this.products.findIndex((obj => obj.id == product_id));
        let stock_quantity = Math.trunc(this.products[objIndex].stock_quantity);
        if(this.quantity<stock_quantity){
          this.quantity++
        }else{
          this.quantity
        }
      }
    },
    decrement(product_id) {

      if (this.quantity === 1) {
      } else {
        this.quantity--;
        let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
        if (objIndex != -1) {
          let oldQuantity = this.carts[objIndex].cart_quantity;
          if (oldQuantity > 1) {
            let newQuantity = oldQuantity - 1;
            let price = this.carts[objIndex].price;
            this.carts[objIndex].cart_quantity = newQuantity;
            this.carts[objIndex].subtotal = price * newQuantity;
            localStorage.setItem("carts", JSON.stringify(this.carts));
            this.carts = JSON.parse(localStorage.getItem("carts"));
            this.calculateCartTotal();
            $("#" + product_id + " .amountQuantity")
              .text(newQuantity);
          }
        }
      }
    },
    restaurantList: function () {
      let vm = this;
      axios.get(this.globalUrl + "restaurants",{crossdomain: true})
        .then(function (response) {
          console.log(response);
          vm.restaurants = response.data.data;
        })
        .catch((response) => {
          vm.$toasted.show('Something wrong  Refresh  again.', {
            type: 'error',
            icon: 'fa-exclamation-triangle'
          });
        });
    },
    quickView: function (index) {

      let vm = this;
      vm.modalProductData = this.products[index];
      //this  is  used  for  just chnage  folder  for  gallery  image and  featured  image in  moddal
      vm.changeModalGallery_image = this.products[index].featured_image;
      let productID = vm.modalProductData.id;
      //console.log(productID);
      const result = this.carts.find(function (obj) {
        return obj.product_id == productID;
      });

      if (result === undefined) {
        vm.quantity = 1;
      } else {
        let oldQuantity = result.cart_quantity;
        vm.quantity = oldQuantity;
      }

    },
    //carts  related  functions
    cartIncrement(product_id) {
      //alert(product_id);
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let stock_quantity = this.carts[objIndex].stock_quantity;
      if(oldQuantity<stock_quantity){
        let newQuantity = oldQuantity + 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        $('#'+product_id+ " .amountQuantity").text(newQuantity);
        this.calculateCartTotal();
        $("#"+product_id).addClass("animated");
        setTimeout(function(){
          $("#"+product_id).removeClass("animated");
        }, 500);
      }
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        $("#" + product_id + " .amountQuantity")
          .text(newQuantity);
        $("#" + product_id)
          .addClass("animated");
        setTimeout(function () {
          $("#" + product_id)
            .removeClass("animated");
        }, 500);
      }

    },
    removeCartItem: function (product_id) {
      //alert(product_id);
      this.carts = this.carts.filter((e) => e.product_id !== product_id);
      $("#" + product_id)
        .removeClass('cartAdded');
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    },
    createCarts: function (index, product_id) {
      let vm = this;
      let thisProductID = product_id;
      $("#" + product_id + " .amountQuantity")
        .text(1);
      //alert(thisProductID);
      //check  array  index  product  info
      //console.log(this.products[index]);
      let check_if_cart_item_exist = this.carts.findIndex(x => x.product_id === this.products[index].id);

      if (check_if_cart_item_exist >= 0) {
        $("#" + thisProductID)
          .addClass('cartAdded');
        let objIndex = this.carts.findIndex(x => x.product_id === this.products[index].id);
        let oldQuantity = this.carts[objIndex].cart_quantity;
        $('#' + thisProductID + " .amountQuantity")
          .text(oldQuantity);

      } else {
        $("#" + thisProductID)
          .addClass('cartAdded');

        //console.log(this.products[index].id);
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null)
          result = [];
        let price = (this.products[index].price - this.products[index].discount);
        //console.log(price);
        result.unshift({
          'product_id': this.products[index].id,
          'product_name': this.products[index].name,
          'product_name_bn': this.products[index].name_bn,
          'product_image': this.products[index].featured_image,
          'price': price,
          'image': this.products[index].featured_image,
          'quantity': this.products[index].unit_quantity,
          'unit': this.products[index].unit,
          'cart_quantity': 1,
          'subtotal': price * 1
        });
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        vm.$toasted.show('New Product Added In your Bag.', {
          type: 'success',
          icon: 'fa-check-circle',
          position: "bottom-left"
        });
        $(".carts")
          .addClass("animated zoomIn");
        $(".cart_amount")
          .addClass("shadow-pulse");
        setTimeout(function () {
          $(".carts")
            .removeClass("animated zoomIn");
          $(".cart_amount")
            .removeClass("shadow-pulse");
        }, 5000);
      }

    },
    createCartsModal: function () {
      let vm = this;
      let this_product_quantity = vm.quantity;
      let singleProduct = vm.modalProductData;
      // alert(singleProduct.id);
      let check_if_cart_item_exist = this.carts.findIndex(x => x.product_id === singleProduct.id);
      if (check_if_cart_item_exist >= 0) {
        vm.$toasted.show('Already Added In your Bag.', {
          type: 'error',
          icon: 'fa-exclamation-triangle',
          position: "bottom-left"
        });
      } else {
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null)
          result = [];
        let price = (singleProduct.price - singleProduct.discount);
        if(this_product_quantity<=singleProduct.stock_quantity){
          this_product_quantity=this_product_quantity;
        }else{
          this_product_quantity=Math.trunc(singleProduct.stock_quantity);
        }
        result.unshift({
          'product_id': singleProduct.id,
          'product_name': singleProduct.name,
          'product_name_bn': singleProduct.name_bn,
          'product_image': singleProduct.featured_image,
          'price': price,
          'image': singleProduct.featured_image,
          'cart_quantity': this_product_quantity,
          'quantity': singleProduct.unit_quantity,
          'unit': singleProduct.unit,
          'stock_quantity': singleProduct.stock_quantity,
          'subtotal': price * this_product_quantity
        });
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        vm.$toasted.show('New Product Added In your Bag.', {
          type: 'success',
          icon: 'fa-check-circle',
          position: "bottom-left"
        });
      }

    },
    calculateCartTotal() {
      let vm = this;
      for (var i = 0, sum = 0; i < vm.carts.length; sum += vm.carts[i++].subtotal) ;
      vm.sum_cart_total = sum;
      for (var i = 0, totalSum = 0; i < vm.carts.length; totalSum += vm.carts[i++].cart_quantity) ;
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge")
        .text(vm.carts.length);
    },
    galleryImg: function (image_url) {
      let vm = this;
      vm.changeModalGallery_image = image_url;
    }
  }
};
</script>
